import { useCallback, useEffect, useState } from 'react';
import { DashboardLayout } from '../common/page_component/index.js';
import Alert from '../common/Alert.js';
import Button from '../common/Button.js';
import Loader from '../common/Loader.js';
import expenseService from '../../services/ExpenseService.js';
import { IndianRupee } from 'lucide-react';

const PaymentIndentQueue = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchQueue = useCallback(async () => {
    try {
      setLoading(true);
      const response = await expenseService.getPaymentQueue();
      setRows(response.data || []);
    } catch (err) {
      Alert.error(err.response?.data?.error || 'Failed to load payment queue');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchQueue();
  }, [fetchQueue]);

  const handlePay = async (expenseId) => {
    const confirmed = await Alert.confirm('Mark this indent as paid?', 'Pay Indent');
    if (!confirmed) return;
    try {
      await expenseService.markAsPaid(expenseId, { payment_mode: 'cash' });
      Alert.success('Indent marked as paid');
      fetchQueue();
    } catch (err) {
      Alert.error(err.response?.data?.error || 'Failed to pay indent');
    }
  };

  return (
    <DashboardLayout>
      <div className="w-full max-w-5xl mx-auto">
        <h1 className="text-xl font-bold text-secondary flex items-center gap-2 mb-4">
          <IndianRupee className="w-5 h-5" /> Daily Payments
        </h1>
        <p className="text-sm text-gray-600 mb-4">
          Admin-approved agent indents ready for payment. Paying posts to cashbook and does not change GC freight.
        </p>
        {loading ? (
          <Loader />
        ) : rows.length === 0 ? (
          <p className="text-sm text-gray-500">No indents waiting for payment.</p>
        ) : (
          <div className="bg-white rounded-xl border border-gray-200 overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th className="text-left px-3 py-2">Indent</th>
                  <th className="text-left px-3 py-2">Date</th>
                  <th className="text-left px-3 py-2">Description</th>
                  <th className="text-right px-3 py-2">Amount</th>
                  <th className="px-3 py-2" />
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.expense_id} className="border-t">
                    <td className="px-3 py-2 font-medium">{row.expense_id}</td>
                    <td className="px-3 py-2">{row.expense_date}</td>
                    <td className="px-3 py-2">{row.description}</td>
                    <td className="px-3 py-2 text-right">₹{Number(row.amount || 0).toFixed(2)}</td>
                    <td className="px-3 py-2 text-right">
                      <Button type="button" onClick={() => handlePay(row.expense_id)}>
                        Pay
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default PaymentIndentQueue;
